import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

interface RaceDetailsWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

const setQuickPickColumnTitle = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            background: ${theme.star.raceSummary.bgColorQuaternary};
            @media ${theme.star.mediaQuery.tablet} {
                border-radius: ${theme.star.radius.medium};
                overflow: hidden;
            }
        `;
    }
    return css``;
};


export const RaceDetailsWrapper = withConfig(theme => styled('div', { label: 'RaceDetailsWrapper' })<RaceDetailsWrapperPropsType>`
    ${({ variant }): SerializedStyles=> setQuickPickColumnTitle(variant, theme)};
`);
